import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
    path: '/permissionManage',
    name: 'PermissionManage',
    meta: {
        title: '权限管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/permissionManage/groupPermissionList',
    children: [{
            path: 'groupPermissionList',
            name: 'GroupPermissionList',
            meta: {
                title: '分组权限列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/permissionManage/groupPermissionList/Index.vue'], resolve),
        },
        {
            path: 'groupPermissionList',
            meta: {
                title: '分组权限列表',
                keepAlive: false
            },
            component: Empty,
            redirect: '/permissionManage/groupPermissionList',
            children: [
                {
                    path: 'setPermission',
                    name: 'setPermission',
                    meta: {
                        title: '设置权限',
                        keepAlive: true
                    },
                    component: resolve => require(['@/views/permissionManage/setPermission/Index.vue'], resolve),
                }
            ]
        },
        {
            path: 'employerList',
            name: 'EmployerList',
            meta: {
                title: '员工列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/permissionManage/employerList/Index.vue'], resolve),
        },
    
    ]
}